import BaseResource from './index'

export default class CustomDocFieldResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/documentFields'
}
